var map = {
	"./atendimento/index.vue": 6186,
	"./cadastros/campos-personalizados.vue": 9770,
	"./cadastros/canais-baileys.vue": 2296,
	"./cadastros/canais-whatsapp.vue": 8390,
	"./cadastros/higienizar-whatsapp.vue": 8452,
	"./cadastros/marca.vue": 9499,
	"./cadastros/origens-captacao.vue": 3482,
	"./cadastros/usuarios.vue": 4146,
	"./campanha/index.vue": 5982,
	"./campanha/respostas.vue": 5774,
	"./canais/detalhe.vue": 1938,
	"./canais/index.vue": 2270,
	"./contato/campos-personalizados.vue": 7763,
	"./contato/importacao.vue": 5756,
	"./contato/index.vue": 3710,
	"./customizacao/marca.vue": 9072,
	"./customizacao/parametros.vue": 3247,
	"./dashboard/index.vue": 5758,
	"./disparo/index.vue": 6495,
	"./grupos/detalhe.vue": 3518,
	"./grupos/index.vue": 1949,
	"./plataforma/espacos.vue": 5669,
	"./rotulo/index.vue": 6528
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2741;
module.exports = webpackAsyncContext;